import { createAsyncActionType } from './index';

export const REGISTRATION_CONTENTS_GET = createAsyncActionType(
  'registration',
  'REGISTRATION_CONTENTS_GET'
);
